<template>
  <div class="help-container">
    <div class="title">
      <h2>帮助（使用手册）</h2>
    </div>
    <div class="text">
      <p>
        5G急救车系统平台（web端）是一款关联救护车和医院信息的平台，以“”技术为核心，提供高速、稳定、低延时的视音频信号，
        实时的信息交互与语音识别，提供定位以及连通车内摄像，保障急救过程顺利进行。
        实现“上车即入院”的理念，打通急救通道中的信息壁垒，车中观察，信息优先处理，专家及时救护，达到下车即急救；
        合理利用急救车的运输时间，提前准备好急救品，真正做到为生命开启“绿色通道”。
      </p>
      <p>
        为提供完美的用户体验，推荐用户采用分屏显示的模式，即两个显示器，一个显示器用于展示视频，一个显示器用于完成信息填写等任务。
      </p>
    </div>
    <div class="photos">
      <img class="first" src="@/assets/photos/纯净模式@2x.png" alt="">
      <img src="@/assets/photos/事件管理@2x.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "Introduction",
};
</script>

<style scoped lang='scss'>
.help-container {
  .title {
    padding-top: 80px;
    padding-bottom: 79px;
    display: flex;
    justify-content: center;

    h2 {
      width: 246px;
      height: 29px;
      font-size: 28px;
      font-weight: bold;
      color: #333333;
    }
  }

  .text {
    width: 837px;
    height: 160px;
    margin: 0 auto;

    p {
      font-size: 14px;
      color: #333333;
    }
  }

  .photos {
    width: 837px;
    height: 160px;
    margin: 0 auto;

    img {
      width: 384px;
      height: 216px;
      background: #EFEFEF;
    }

    .first {
      padding-right: 69px;
    }
  }

}
</style>
